/**
 * When a frame is missing, Turbo by default simply renders "Content missing ..."
 * message. This is not particularly useful. Especially when it's due to a server
 * error instead being a logic flow error. It's possible that retrying the frame
 * request would resolve the issue.
 *
 * This controller allows to override the default behavior and instead show a
 * custom message.
 *
 * The alternative content that you want to show inside the frame should be
 * placed inside "content" target element. The inner content of the target will be
 * deep cloned and inserted inside the frame element on which the turbo:frame-missing
 * event is triggered.
 *
 * It's best to use a `template` element so it's not visible before being used.
 *
 * @example
 * div data-controller="custom-content-missing"
 *   template data-custom-content-missing-target="content"
 *     = render "front/rooms/retry_content_missing"
 *   = turbo_frame_tag :reviews_preview, src: url, loading: :eager
 *
 * NOTE: When this is attached to an element this will automatically work for
 * all turbo frames inside the element. If the content missing doesn't hard code
 * links but instead just triggers frame reloading, the fix will just work for all
 * frames. You can use `smth-went-wrong` controller for this. You just need to
 * make sure that the custom content looks acceptable on all frames.
 */
stimulusApp.register(
  "custom-content-missing",
  class extends Stimulus.Controller {
    static targets = ["content"]

    connect() {
      this.element.addEventListener(
        "turbo:frame-missing",
        this.#useCustomContent,
      )
    }

    disconnect() {
      this.element.removeEventListener(
        "turbo:frame-missing",
        this.#useCustomContent,
      )
    }

    #useCustomContent = (event) => {
      if (this.hasContentTarget) {
        event.preventDefault()
        const content = this.contentTarget.content.cloneNode(true)
        event.target.innerHTML = ""
        event.target.append(content)
      }
    }
  },
)
